import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useT } from "../i18n";
import { getOrderStatus, saveCart } from "../lib/shopApi";

export default function ShopSuccess() {
  const t = useT();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const data = await getOrderStatus(sessionId);
        if (data.payment_status === "paid" || tries >= 8) {
          setOrder(data);
          if (data.payment_status === "paid") saveCart([]);
          return;
        }
      } catch {
        /* keep polling */
      }
      tries += 1;
      setTimeout(poll, 2000);
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-bergamote-50 flex items-center justify-center px-5">
      <div className="max-w-md w-full bg-cream-50 border border-bergamote-600/15 rounded-3xl p-8 sm:p-10 text-center" data-testid="order-success-card">
        <CheckCircle2 className="w-12 h-12 text-bergamote-600 mx-auto mb-5" />
        <h1 className="font-serif text-3xl font-semibold text-bergamote-900" data-testid="order-success-title">
          {order ? t.sh_success_title : t.sh_checking}
        </h1>
        {order && (
          <>
            <p className="mt-3 text-sm text-bergamote-800/70">{t.sh_success_sub}</p>
            <div className="mt-6 text-left space-y-2 border-t border-bergamote-600/10 pt-5" data-testid="order-summary">
              {order.items.map((i, idx) => (
                <div key={idx} className="flex justify-between text-sm">
                  <span className="text-bergamote-800">{i.name} — {i.size} × {i.quantity}</span>
                  <span className="font-mono text-bergamote-900">CHF {(i.unit_price * i.quantity).toFixed(2)}</span>
                </div>
              ))}
              <div className="flex justify-between font-mono font-semibold pt-2 border-t border-bergamote-600/10">
                <span>Total</span>
                <span data-testid="order-total">CHF {order.total.toFixed(2)}</span>
              </div>
            </div>
          </>
        )}
        <Link
          to="/shop"
          data-testid="back-to-shop"
          className="mt-8 inline-block rounded-full border border-bergamote-600/40 text-bergamote-800 px-7 py-3 text-sm font-semibold hover:bg-bergamote-100 transition-colors"
        >
          {t.sh_back_shop}
        </Link>
      </div>
    </div>
  );
}
